// import { useSortable } from "@dnd-kit/sortable";
// import { CSS } from "@dnd-kit/utilities";
// import React, { useState } from "react";
// import { GoGear } from "react-icons/go";
// import { RiDeleteBinLine } from "react-icons/ri";

// const SortableItem = ({
//   id,
//   children,
//   onDelete,
//   onApplyProperties,
//   handleSetting,
//   field,
// }) => {
//   const { attributes, listeners, setNodeRef, transform, transition } =
//     useSortable({ id });
//   const [isHovered, setIsHovered] = useState(false);
//   const [isFocused, setIsFocused] = useState(false);

//   const style = {
//     transform: CSS.Transform.toString(transform),
//     transition,
//     position: "relative",
//     zIndex: isHovered ? 1 : 0, // Ensuring the hover buttons are above other elements
//   };

//   const dragProps = { ...attributes, ...listeners };

//   const handleDeleteClick = (event) => {
//     event.preventDefault(); // Prevents triggering drag when clicking delete
//     onDelete(id);
//   };

//   const handleApplyPropertiesClick = (e) => {
//     e.preventDefault();
//     handleSetting(field); // pass full block
//   };

//   return (
//     <>
//       <div
//         ref={setNodeRef}
//         style={style}
//         onMouseEnter={() => setIsHovered(true)}
//         onMouseLeave={() => setIsHovered(false)}
//       >
//         <div
//           {...dragProps}
//           onFocus={() => setIsFocused(true)}
//           onBlur={() => setIsFocused(false)}
//         >
//           {children}
//         </div>
//         {isHovered && (
//           <div
//             className="flex"
//             style={{
//               position: "absolute",
//               top: 0,
//               right: 0,
//             }}
//           >
//             <GoGear
//               className="cursor-pointer"
//               size={20}
//               onClick={handleApplyPropertiesClick}
//             />
//             <RiDeleteBinLine
//               className="cursor-pointer"
//               size={20}
//               onClick={handleDeleteClick}
//             />
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default SortableItem;

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GoGear } from "react-icons/go";
import { RiDeleteBinLine } from "react-icons/ri";

const SortableItem = ({ id, field, onDelete, onEdit, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 6,
    padding: 16,
    // marginBottom: 10,
    position: "relative",
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div {...attributes} {...listeners}>
        {children}
      </div>

      <div style={{ position: "absolute", top: 14, right: 6 }}>
        <GoGear
          style={{ cursor: "pointer", marginRight: 6 }}
          onClick={() => onEdit(field)}
        />
        <RiDeleteBinLine
          style={{ cursor: "pointer" }}
          onClick={() => onDelete(id)}
        />
      </div>
    </div>
  );
};

export default SortableItem;
